import { Pipe, PipeTransform, inject } from '@angular/core';
import { BdCompanyGroup } from '@bindoc-projects/resource-domain-lib';
import { BdPermissionsGroupsAdminService } from './groups-admin.service';
import { firstValueFrom } from 'rxjs';

@Pipe({
  name: 'groupAdmin',
  standalone: true,
})
export class BdPermissionGroupAdminPipe implements PipeTransform {
  private _permissionService = inject(BdPermissionsGroupsAdminService);


  transform(value: string): Promise<BdCompanyGroup | null> {
    return firstValueFrom(this._permissionService.getById(value));
  }
}
